// @flow

import * as React from 'react';
import { InteractionLogger, TrackingNamespaceContext } from '@ta/tracking.interactions';
import { featureIsEnabled } from '@ta/common.features';
import classNames from '@ta/common.classnames';
import { Device } from '@ta/lithium.context';
import styles from './GeoOverviewQuickLinks.css';

type Route = {|
  url: string,
|};

type QuickLink = {|
  forceCollapse: boolean,
  trackingKey: string,
  route: Route,
  title: string,
|};

type QuickLinks = {|
  quickLinks: QuickLink[],
|};

type Props = {
  orderedQuickLinks: QuickLinks,
};

const isLinkEnabled = (trackingKey: string) => {
  switch (trackingKey) {
    case 'RENTAL_CARS':
      return featureIsEnabled('rental_cars_winning_quick_link');
    case 'CRUISES':
      return featureIsEnabled('cruise');
    case 'VACATION_RENTALS':
      return featureIsEnabled('vacation_rentals');
    case 'VACATION_PACKAGES':
      return featureIsEnabled('seo_vacation_packages_servlet');
    default:
      return true; // The above are special cases, the rest should be enabled
  }
};

const GeoOverviewQuickLinks = ({ orderedQuickLinks }: Props) => {
  const [clickedLink, setClickedLink] = React.useState(null);
  const { viewportCategory } = React.useContext(Device);
  return (
    <TrackingNamespaceContext.Provider value="home">
      <div className={styles.quickLinks}>
        {orderedQuickLinks.quickLinks.map(
          link =>
            !link.forceCollapse &&
            isLinkEnabled(link.trackingKey) && (
              <InteractionLogger>
                {logInteraction => (
                  <a
                    key={link.trackingKey}
                    className={classNames(styles.quickLink, {
                      [styles.clicked]:
                        clickedLink === link.trackingKey && viewportCategory !== 'DESKTOP',
                    })}
                    href={link.route.url}
                    onClick={e => {
                      setClickedLink(link.trackingKey);
                      logInteraction(e, 'quickLinkFeedClick', {
                        trackingKey: link.trackingKey,
                      });
                      return true;
                    }}
                  >
                    {link.title}
                  </a>
                )}
              </InteractionLogger>
            ),
        )}
      </div>
    </TrackingNamespaceContext.Provider>
  );
};

export default GeoOverviewQuickLinks;
